import * as React from "react"
import { useLocation } from 'react-router-dom';
import { Box, Button, Tooltip, IconButton, Menu, MenuItem, Chip, Autocomplete, TextField, CircularProgress, Collapse, Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material"
import Grid from "@mui/material/Grid2"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { AXIOS_API_INSTANCE, LONG_DATE_FORMAT, SERVICE_ORDER_CUSTOMER_APPROVAL_COLOR_MAP, SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import HistoryIcon from '@mui/icons-material/History';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
import TimerIcon from '@mui/icons-material/Timer';
import CalculateIcon from '@mui/icons-material/Calculate';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EditIcon from '@mui/icons-material/Edit';
import HandymanIcon from '@mui/icons-material/Handyman';
import CloseIcon from '@mui/icons-material/Close';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import dayjs from "dayjs"
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop"
import { useSnackbar } from 'notistack';
import TabPanel from "../../Utils/tabpanel"
import { useNavigate } from "react-router-dom"
import ServiceOrderService from "./ServiceOrderService"
import AddServiceOrderServiceModal from "./Modals/AddServiceOrderServiceModal"
import ChangeServiceOrderStatusModal from "./Modals/ChangeServiceStatusModal"
import ServiceOrderNotes from "./ServiceOrderNotes"
import ChangeCustomerApprovalStatusModal from "./Modals/ChangeCustomerApprovalStatusModal"
import StopWorkModal from "./Modals/StopWorkModal"
import UserAvatar from "../UserAvatar"
import { generate_service_order_label, print_zebra_label_cloud } from "../../Utils/zebra"
import PaymentPage from "../Payment/PaymentPage"
import ServiceOrderQuoteInvoice from "./ServiceOrderQuoteInvoice"
import TooltipTab from "../../Utils/TooltipTab";
import CustomerItemModal from './Modals/CustomerItemModal';
import CustomerItemHistoryModal from "./Modals/CustomerItemHistoryModal";
import ServiceOrderWarrantyModal from "./Modals/ServiceOrderWarrantyModal";
import ServiceOrderEventsModal from "./Modals/ServiceOrderEventsModal";
import ServiceOrderFilesModal from "./Modals/ServiceOrderFilesModal";
import ServiceOrderStatusDropdown from "./ServiceOrderStatusDropdown";
import axios from "axios";
import CustomerModal from "../CustomerModal";
import InputModal from "../modals/InputModal";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { build_users_list, findUser, useUsers } from "../ReactQuery/QueryUsers";
import { useTrackedDarkMode, useTrackedServiceInputInMinutes, useTrackedUser, useTrackedUserOpenServiceOrderWorkHistory } from "../UserState";
import { findLocation, useLocations } from "../ReactQuery/QueryLocations";
import CurrentLocationModal from "./Modals/CurrentLocationModal";
import DocumentTitle from "../../Utils/DocumentTitle";
import { formatCustomerName, formatDuration, formatPhoneNumber } from "../../Utils";
import { ExpandMore } from "../../Utils/ExpandMore";
import SelectModal from "../modals/SelectModal";
import { findServiceOrderItemType, useServiceOrderItemTypes } from "../ReactQuery/QueryServiceOrderItemTypes";
import PendingServicesModal from "./Modals/PendingServicesModal";
import ServiceOrderPreferredContact from "./ServiceOrderPreferredContact";
import AIButton from "../../Utils/AIButton";
import CustomerCommunicationModal from "./Modals/CustomerCommunicationModal";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import ChangeServiceOrderCustomerModal from "./Modals/ChangeServiceOrderCustomerModal";

const NEW_WARRANTY = {
    'claim_number': '',
    'status': 'Created',
    'vendor': '',
    'approved_for_discount': false,
    'new': true
}

const ShopFeesCalculation = (serviceOrder, calculatedCosts, warrantiedServices, warrantiedParts, inputInMinutes) => {
    var total_service_cost = 0
    var total_parts_cost = 0
    Object.keys(calculatedCosts.services).forEach((service_id) => {
        const service = calculatedCosts.services[service_id]
        var service_cost = parseFloat(service.flat_rate) + (parseFloat(service.hourly_rate) * parseFloat(service.minutes_worked) / (inputInMinutes ? 60 : 1))
        var parts_cost = Object.keys(service.parts).reduce((accumulator, item) => {
            const part = service.parts[item]
            return accumulator + (parseFloat(part.actual_cost) * parseFloat(part.quantity))
        }, 0)
        total_service_cost += service_cost
        total_parts_cost += parts_cost
    })
    let total_warranties_service = 0
    let total_warranties_parts = 0
    Object.keys(warrantiedServices).forEach((service_id) => {
        total_warranties_service += Object.keys(warrantiedServices[service_id] ?? {}).reduce((accumulator, warranty_id) => accumulator + parseFloat(warrantiedServices[service_id][warranty_id].association.estimated_coverage), 0)
    })
    Object.keys(warrantiedParts).forEach((part_id) => {
        total_warranties_parts += Object.keys(warrantiedParts[part_id] ?? {}).reduce((accumulator, warranty_id) => accumulator + parseFloat(warrantiedParts[part_id][warranty_id].association.estimated_coverage), 0)
    })
    total_service_cost -= total_warranties_service
    total_parts_cost -= total_warranties_parts
    var shop_fees = 0
    if (serviceOrder?.location_service_fees) {
        if (serviceOrder.location_service_fees.shop_fee_percentage) {
            if (serviceOrder.location_service_fees.shop_fee_include_service) {
                shop_fees += (total_service_cost) * serviceOrder.location_service_fees.shop_fee_percentage / 100
            }
            if (serviceOrder.location_service_fees.shop_fee_include_parts) {
                shop_fees += (total_parts_cost) * serviceOrder.location_service_fees.shop_fee_percentage / 100
            }
        }
        if (serviceOrder.location_service_fees.shop_fee_minimum) {
            shop_fees = Math.max(shop_fees, serviceOrder.location_service_fees.shop_fee_minimum)
        }
        if (serviceOrder.location_service_fees.shop_fee_maximum) {
            shop_fees = Math.min(shop_fees, serviceOrder.location_service_fees.shop_fee_maximum)
        }
    }
    return shop_fees
}

const calculateCosts = (serviceOrder, warrantiedServices, warrantiedParts, warrantiedCharges, inputInMinutes) => {
    const myCalculatedCosts = {
        summary_notes: serviceOrder?.summary_notes,
        services: {},
        adjustments: {},
        fees: {},
        ISQUOTE: ['CREATED', 'IN_PROGRESS'].includes(serviceOrder?.status_type),
    };
    (serviceOrder?.service_order_services ?? []).forEach((service) => {
        const declined = service.status === 'DECLINED'
        myCalculatedCosts.services[service.id] = {
            hourly_rate: 0,
            flat_rate: 0,
            minutes_worked: 0,
            summary_notes: service.summary_notes || '',
            parts: {},
        }
        if (!declined) {
            if (['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type)) {
                myCalculatedCosts.services[service.id]["flat_rate"] = service.quoted_flat_rate ?? service.default_flat_rate
                myCalculatedCosts.services[service.id]["minutes_worked"] = Math.round(((service.quoted_minutes_worked ?? service.default_minutes_worked) / (inputInMinutes ? 1 : 60)) * 100000) / 100000 // Extending precision out to support hours/minutes conversion
                myCalculatedCosts.services[service.id]["hourly_rate"] = service.quoted_hourly_rate ?? service.default_hourly_rate
            } else {
                myCalculatedCosts.services[service.id]["flat_rate"] = (service.official_flat_rate ?? service.quoted_flat_rate) ?? service.default_flat_rate
                myCalculatedCosts.services[service.id]["minutes_worked"] = Math.round((((service.official_minutes_worked ?? service.quoted_minutes_worked) ?? service.default_minutes_worked) / (inputInMinutes ? 1 : 60)) * 100000) / 100000 // Extending precision out to support hours/minutes conversion
                myCalculatedCosts.services[service.id]["hourly_rate"] = (service.official_hourly_rate ?? service.quoted_hourly_rate) ?? service.default_hourly_rate
            }
        }
        service.service_order_parts.forEach((part) => {
            myCalculatedCosts.services[service.id]["parts"][part.id] = {
                "actual_cost": Math.round(part.cost * (service.part_price_adjustment + 100)) / 100,
                "quantity": part.quantity,
                "quoted_cost": part.quoted_cost ?? 0,
                "quoted_quantity": part.quoted_quantity ?? 0
            }
            if (declined || part.status_type === 'DECLINED') {
                myCalculatedCosts.services[service.id]["parts"][part.id].actual_cost = 0
            } else if (['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type)) {
                myCalculatedCosts.services[service.id]["parts"][part.id].actual_cost = part.quoted_cost ?? myCalculatedCosts.services[service.id]["parts"][part.id].actual_cost
            } else {
                myCalculatedCosts.services[service.id]["parts"][part.id].actual_cost = (part.actual_cost ?? part.quoted_cost) ?? myCalculatedCosts.services[service.id]["parts"][part.id].actual_cost
            }
        })
    });
    (serviceOrder?.service_order_charges ?? []).filter((x) => x.charge_type === 'ADJUSTMENT').forEach((adjustment) => {
        myCalculatedCosts.adjustments[adjustment.id] = {
            id: adjustment.id,
            new: false,
            description: adjustment.description,
            sku: adjustment.sku,
            actual_cost: adjustment.actual_cost,
            estimated_cost: adjustment.estimated_cost,
            tax_rate: adjustment.tax_rate,
            date_created: adjustment.date_created
        }
    });
    (serviceOrder?.service_order_charges ?? []).filter((x) => x.charge_type === 'FEE').forEach((fee) => {
        myCalculatedCosts.fees[fee.id] = {
            id: fee.id,
            new: false,
            name: fee.name,
            description: fee.description,
            calculation_data: fee.calculation_data,
            edited: fee.edited,
            sku: fee.sku,
            actual_cost: fee.actual_cost,
            estimated_cost: fee.estimated_cost,
            tax_rate: fee.tax_rate,
            service_order_fee_id: fee.service_order_fee_id,
            date_created: fee.date_created
        }
    })

    const shop_fee_charge = (serviceOrder?.service_order_charges ?? []).find((x) => x.charge_type === 'SHOP_FEES')
    if (shop_fee_charge) {
        myCalculatedCosts.shop_fees_calculated = Math.round(ShopFeesCalculation(serviceOrder, myCalculatedCosts, warrantiedServices, warrantiedParts, inputInMinutes) * 100) / 100
        myCalculatedCosts.shop_fees_tax_rate = shop_fee_charge.tax_rate
        if (shop_fee_charge.description === 'MANUAL') {
            myCalculatedCosts.shop_fees_manual = shop_fee_charge.actual_cost
        }
    }
    return myCalculatedCosts
}

const getWarrantiedServices = (serviceOrder) => {
    const services = {}
    serviceOrder.service_order_warranties.forEach((warranty) => {
        warranty.service_order_services_association.forEach((association) => {
            services[association.service_order_service_id] = services[association.service_order_service_id] ?? {}
            services[association.service_order_service_id][warranty.id] = { 'warranty': warranty, 'association': association }
        })
    })
    return services
}

const getWarrantiedParts = (serviceOrder) => {
    const parts = {}
    serviceOrder.service_order_warranties.forEach((warranty) => {
        warranty.service_order_parts_association.forEach((association) => {
            parts[association.service_order_part_id] = parts[association.service_order_part_id] ?? {}
            parts[association.service_order_part_id][warranty.id] = { 'warranty': warranty, 'association': association }
        })
    })
    return parts
}

const getWarrantiedCharges = (serviceOrder) => {
    const charges = {}
    serviceOrder.service_order_warranties.forEach((warranty) => {
        warranty.service_order_charges_association.forEach((association) => {
            charges[association.service_order_charge_id] = charges[association.service_order_charge_id] ?? {}
            charges[association.service_order_charge_id][warranty.id] = { 'warranty': warranty, 'association': association }
        })
    })
    return charges
}

const populateWarranties = (serviceOrder) => {
    const myServiceOrderWarranties = serviceOrder.service_order_warranties
    myServiceOrderWarranties.forEach((warranty) => {
        warranty.service_order_services_association.forEach((service_assoc) => {
            service_assoc.service_order_service = serviceOrder.service_order_services.filter((service) => service.id.toString() === service_assoc.service_order_service_id.toString())[0]
        });
        warranty.service_order_parts_association.forEach((part_assoc) => {
            serviceOrder.service_order_services.forEach((service) => {
                service.service_order_parts.forEach((part) => {
                    if (part.id.toString() === part_assoc.service_order_part_id.toString()) {
                        part_assoc.service_order_part = part
                        return
                    }
                })
            })
        });
        warranty.service_order_charges_association.forEach((charge_assoc) => {
            charge_assoc.service_order_charge = serviceOrder.service_order_charges.filter((charge) => charge.id.toString() === charge_assoc.service_order_charge_id.toString())[0]
        });
    });
    return [...myServiceOrderWarranties]
}

function StartWorkButton({
    serviceOrder,
    setOpenServiceOrderWorkHistory,
    setPendingServicesModal,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_user,] = useTrackedUser();
    const [saving, setSaving] = React.useState(false)

    const start_work = (event) => {
        setSaving(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/start_work`, {}).then((serviceOrder) => {
                enqueueSnackbar('Successfully started work', { variant: 'success' })
                setSaving(false)
                setOpenServiceOrderWorkHistory(serviceOrder.data.data.service_order_work_history.filter((x) => x.end_time === null && x.user_id === my_user.id)[0])
                const pending_services = serviceOrder.data.data.service_order_services.some((service) => service.status === 'PENDING' && service.customer_approved_status === 'APPROVED')
                if (pending_services) {
                    setPendingServicesModal(true)
                }
            }).catch((error) => {
                setSaving(false)
                enqueueSnackbar(`Failed to start work <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }
    return (
        <Button color='primary' variant='contained' onClick={start_work} disabled={saving}>
            {saving ? <CircularProgress color={'white'} size={24} /> : <TimerIcon />}<Box sx={{ pl: 1 }}>Start Work</Box>
        </Button>
    )
}

export default function ServiceOrder(
    {
        serviceOrderId,
        setMadeUpdate,
        closeFunction
    }
) {
    DocumentTitle(`#${serviceOrderId} | Service Orders`)
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const [openServiceOrderWorkHistory, setOpenServiceOrderWorkHistory] = useTrackedUserOpenServiceOrderWorkHistory();
    const [inputInMinutes,] = useTrackedServiceInputInMinutes();
    const { data: serviceorderitemtypes } = useServiceOrderItemTypes();
    const { data: users, isSuccess: loadedUsers } = useUsers();
    const { data: locations, } = useLocations();
    const [my_user,] = useTrackedUser();
    const [darkMode,] = useTrackedDarkMode();
    const [serviceOrder, setServiceOrder] = React.useState(undefined)
    const [tab, setTab] = React.useState((location.hash || "#details").substring(1))
    const [serviceOrderLoadingStep, setServiceOrderLoadingStep] = React.useState(0)
    const [serviceOrderSavingStep, setServiceOrderSavingStep] = React.useState(0)
    const [serviceOrderFilesUploadStep, setServiceOrderFilesUploadStep] = React.useState(0)
    const [serviceOrderOptionsAnchorEl, setServiceOrderOptionsAnchorEl] = React.useState(null)
    const [serviceOrderItemOptionsAnchorEl, setServiceOrderItemOptionsAnchorEl] = React.useState(null)
    const [customerModalOpen, setCustomerModalOpen] = React.useState(false)
    const [openCustomerCommunicationModal, setOpenCustomerCommunicationModal] = React.useState(false)
    const [customerItemModal, setCustomerItemModal] = React.useState({
        open: false,
        customerItem: {}
    })
    const [customerItemHistoryModal, setCustomerItemHistoryModal] = React.useState(false)
    const [customerItemExpanded, setCustomerItemExpanded] = React.useState(false)
    const [pendingServicesModal, setPendingServicesModal] = React.useState(false)
    const [selectModal, setSelectModal] = React.useState({
        open: false,
        callback: null,
        options: []
    })
    const [serviceOrderSummaryNotesModal, setServiceOrderSummaryNotesModal] = React.useState({
        open: false,
        label: 'Order Summary Notes (Customer Visible)',
        callback: (results, value) => {
            setServiceOrderSummaryNotesModal({ ...serviceOrderSummaryNotesModal, open: false })
            if (results) {
                setServiceOrderSavingStep(1)
                const body = {
                    summary_notes: value
                }
                send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/update_summary_notes`, body).then((serviceOrder) => {
                    enqueueSnackbar('Successfully updated summary notes', { variant: 'success' })
                    setServiceOrder(serviceOrder.data.data)
                    setMadeUpdate(true)
                    setServiceOrderSavingStep(0)
                }).catch((error) => {
                    console.log(error);
                    enqueueSnackbar(`Failed to update service name: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                    setServiceOrderSavingStep(0)
                }))
            }
        },
        title: 'Edit Summary Notes',
        defaultInput: '',
        maxWidth: 'md',
        multiline: true,
        minRows: 3
    })

    const [addServiceModalOpen, setAddServiceModalOpen] = React.useState(false);
    const [eventsModalOpen, setEventsModalOpen] = React.useState(false);
    const [filesModalOpen, setFilesModalOpen] = React.useState(false);
    const [currentLocationModalOpen, setCurrentLocationModalOpen] = React.useState(false);
    const [statusModalOpen, setStatusModalOpen] = React.useState({
        open: false,
        status_types: [],
        allow_notes: true,
        callback: null
    });
    const [changeCustomerApprovalStatusModalOpen, setChangeCustomerApprovalStatusModalOpen] = React.useState(false);
    const [stopWorkModalOpen, setStopWorkModalOpen] = React.useState(false);
    const [changeServiceOrderCustomerModalOpen, setChangeServiceOrderCustomerModalOpen] = React.useState(false);
    const [warrantiedServices, setWarrantiedServices] = React.useState({})
    const [warrantiedParts, setWarrantiedParts] = React.useState({})
    const [warrantiedCharges, setWarrantiedCharges] = React.useState({})
    const [calculatedCosts, setCalculatedCosts] = React.useState(calculateCosts(serviceOrder, warrantiedServices, warrantiedParts, warrantiedCharges, inputInMinutes))
    const [selectedWarranty, setSelectedWarranty] = React.useState(undefined)
    const navigate = useNavigate();
    const ISQUOTE = ['CREATED', 'IN_PROGRESS'].includes(serviceOrder?.status_type)
    const SERVICE_ORDER_ITEM_TYPE = findServiceOrderItemType(serviceorderitemtypes, serviceOrder?.customer_item?.service_order_item_type_id)
    const workHistoryColumns = [
        {
            field: "start_time",
            type: "string",
            headerName: "Time",
            width: 125,
            editable: false,
            sortable: true,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Grid container alignItems="center" sx={{ height: '100%' }}>
                        <Tooltip title={`${dayjs.utc(params.row.start_time).local().format(LONG_DATE_FORMAT)} - ${dayjs.utc(params.row.end_time).local().format(LONG_DATE_FORMAT)}`}>
                            <span>{dayjs.utc(params.row.start_time).local().format("MM/DD/YYYY")}</span>
                        </Tooltip>
                    </Grid>
                )
            }
        },
        {
            field: "user_id",
            headerName: "Worker",
            width: 135,
            editable: false,
            sortable: true,
            filterable: false,
            renderCell: (params) => {
                const user = findUser(users, params.row.user_id)
                return (
                    (<Grid container space={1} alignItems="center" sx={{ height: '100%' }}>
                        <Grid sx={{ pr: 1 }} size="auto">
                            <span><UserAvatar user={user} tooltip={user?.name} /></span>
                        </Grid>
                    </Grid>)
                );
            }
        },
        {
            field: "diagnostic_minutes",
            headerName: "Duration",
            width: 100,
            editable: false,
            sortable: false,
            filterable: false,
            valueGetter: (value, row) => row.diagnostic_minutes,
            valueFormatter: (value) => formatDuration(value),
            renderCell: (params) => {
                return (
                    <Grid container alignItems="center" sx={{ height: '100%' }}>
                        <span>{params.formattedValue}</span>
                    </Grid>
                );
            }
        },
        {
            field: "note",
            headerName: "Comments",
            flex: 1,
            editable: false,
            sortable: false,
            filterable: false,
            valueGetter: (value, row) => row.diagnostic_note,
        },
    ]

    const closeModalFunction = (setChangeStatus) => (results) => {
        if (results) {
            setServiceOrder(results)
            setMadeUpdate(true)
        }
        setChangeStatus(false)
    }

    const paymentUpdate = (changes) => {
        if (changes) {
            getData()
        }
    }

    const editCustomerItemClick = () => {
        setCustomerItemModal({
            customerItem: serviceOrder.customer_item,
            open: true
        })
    }
    const closeCustomerItemModal = (results) => {
        if (results) {
            getData()
        }
        setCustomerItemModal({
            customerItem: {},
            open: false
        })
    }

    const uploadNewFile = (event, setLoadingStep) => {
        console.log(event)
        if (!event.target.files || event.target.files.length === 0) {
            return;
        }
        const file = event.target.files[0];
        setLoadingStep(1)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/add_file`, { file_name: file.name },).then((response) => {
                var bodyFormData = new FormData();
                for (const key in response.data.data.fields) {
                    bodyFormData.append(key, response.data.data.fields[key])
                }
                bodyFormData.append('file', file)
                axios.post(response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                    enqueueSnackbar('Successfully uploaded file', { variant: 'success' })
                    setLoadingStep(0)
                    setServiceOrder({ ...serviceOrder, random: Date.now() })
                    setMadeUpdate(true)
                }).catch((error) => {
                    console.log(error);
                    enqueueSnackbar(`Failed to upload file: ${error?.response ?? "Unknown Error Occurred"}`, { variant: 'error' })
                    setLoadingStep(0)
                })
            }).catch((error) => {
                console.log(error);
                enqueueSnackbar(`Failed to upload file: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                setLoadingStep(0)
            })
        )
    }

    const setAssignee = (assignee) => {
        const new_assignee = {
            user_id: assignee?.id,
        }
        if (assignee === undefined || assignee === null || assignee.id === -1) {
            new_assignee.user_id = null
        }
        // Skip if the assignee is the same as the current one
        if (new_assignee.user_id === serviceOrder.assignee_user_id) {
            return
        }
        setServiceOrderSavingStep(1)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/change_assignee`, new_assignee).then((serviceOrder) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar('Successfully changed assignee', { variant: 'success' })
                setServiceOrder(serviceOrder.data.data)
                setMadeUpdate(true)
            }).catch((error) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar(`Failed to change assignee <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    const getData = () => {
        setServiceOrderLoadingStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.get(`serviceorders/${serviceOrderId}`).then((new_serviceOrder) => {
            new_serviceOrder.data.data.actively_worked = new_serviceOrder.data.data.service_order_work_history.some((entry) => entry.end_time === null)
            setCalculatedCosts(calculateCosts(new_serviceOrder.data.data, warrantiedServices, warrantiedParts, warrantiedCharges, inputInMinutes))
            if (serviceOrder !== undefined) {
                setMadeUpdate(true)
            }
            setServiceOrder(new_serviceOrder.data.data)
            setServiceOrderLoadingStep(0)
            if (tab === "invoice" && ['CREATED', 'IN_PROGRESS'].includes(new_serviceOrder.data.data.status_type)) {
                setTab("quote")
            } else if (tab === "quote" && !['CREATED', 'IN_PROGRESS'].includes(new_serviceOrder.data.data.status_type)) {
                setTab("invoice")
            }
        }).catch((error) => {
            console.log(error);
            enqueueSnackbar(`Failed to load service order: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
            navigate('/ServiceOrders')
        }))
    }

    const complete_service_order = () => {
        setStatusModalOpen({
            open: true,
            status_types: ['COMPLETED'],
            title: 'Complete Service Order',
            allow_notes: true,
            allow_customer_communication: true,
            callback: (change, status, notes, customer_communication_object) => {
                if (change) {
                    setServiceOrderSavingStep(1)
                    const body = {
                        'status': status,
                        'notes': notes.trim()
                    }
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/complete`, body).then((serviceOrderNew) => {
                        enqueueSnackbar(`Successfully completed service order`, { variant: 'success' })
                        setMadeUpdate(true)
                        if (customer_communication_object) {
                            send_authorized_request(() =>
                                AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/send_customer_communication`, customer_communication_object).then((serviceOrderNewNew) => {
                                    enqueueSnackbar(`Successfully sent ${customer_communication_object.destination_type === 'email' ? 'email' : 'text'} to customer (${customer_communication_object.destination_type === 'email' ? customer_communication_object.destination : formatPhoneNumber(customer_communication_object.destination)})`, { variant: 'success' })
                                    setServiceOrderSavingStep(0)
                                    setServiceOrder(serviceOrderNewNew.data.data)
                                }).catch((error) => {
                                    setServiceOrderSavingStep(0)
                                    enqueueSnackbar(`Failed to send ${customer_communication_object.destination_type === 'email' ? 'email' : 'text'} to customer (${customer_communication_object.destination_type === 'email' ? customer_communication_object.destination : formatPhoneNumber(customer_communication_object.destination)}) <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                                    setServiceOrder(serviceOrderNew.data.data)
                                }))
                        } else {
                            setServiceOrder(serviceOrderNew.data.data)
                            setServiceOrderSavingStep(0)
                        }
                    }).catch((error) => {
                        console.log(error);
                        enqueueSnackbar(`Failed to complete service order: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                        setServiceOrderSavingStep(0)
                    }))
                }
                setStatusModalOpen({ open: false, status_types: [], allow_notes: true, callback: null })
            }
        })
    }

    const cancel_service_order = () => {
        setStatusModalOpen({
            open: true,
            status_types: ['DECLINED'],
            title: 'Cancel Service Order',
            allow_notes: true,
            allow_customer_communication: false,
            callback: (change, status, notes) => {
                if (change) {
                    setServiceOrderSavingStep(1)
                    const body = {
                        'status': status,
                        'notes': notes.trim()
                    }
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/cancel`, body).then((serviceOrder) => {
                        setServiceOrder(serviceOrder.data.data)
                        setMadeUpdate(true)
                        setServiceOrderSavingStep(0)
                    }).catch((error) => {
                        console.log(error);
                        enqueueSnackbar(`Failed to cancel service order: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                        setServiceOrderSavingStep(0)
                    }))
                }
                setStatusModalOpen({ open: false, status_types: [], allow_notes: true, callback: null })
            }
        })
    }

    const reopen_service_order = () => {
        setStatusModalOpen({
            open: true,
            status_types: ['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].concat(serviceOrder?.status_type === 'COMPLETED' ? ['INVOICED'] : []),
            title: "Reopen Service Order",
            allow_notes: true,
            allow_customer_communication: false,
            callback: (change, status, notes) => {
                if (change) {
                    setServiceOrderSavingStep(1)
                    const body = {
                        'status': status,
                        'notes': notes.trim()
                    }
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/reopen`, body).then((serviceOrder) => {
                        setServiceOrder(serviceOrder.data.data)
                        setMadeUpdate(true)
                        setServiceOrderSavingStep(0)
                    }).catch((error) => {
                        console.log(error);
                        enqueueSnackbar(`Failed to reopen service order: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                        setServiceOrderSavingStep(0)
                    }))
                }
                setStatusModalOpen({ open: false, status_types: [], allow_notes: true, title: "Reopen Service Order", callback: null })
            }
        })
    }

    const revert_from_invoiced = () => {
        setStatusModalOpen({
            open: true,
            status_types: ['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'],
            title: "Revert Invoicing",
            allow_notes: true,
            allow_customer_communication: false,
            callback: (change, status, notes) => {
                if (change) {
                    setServiceOrderSavingStep(1)
                    const body = {
                        'status': status,
                        'notes': notes.trim()
                    }
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/revert_from_invoiced`, body).then((serviceOrder) => {
                        setServiceOrder(serviceOrder.data.data)
                        setMadeUpdate(true)
                        setServiceOrderSavingStep(0)
                    }).catch((error) => {
                        console.log(error);
                        enqueueSnackbar(`Failed to revert service order: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                        setServiceOrderSavingStep(0)
                    }))
                }
                setStatusModalOpen({ open: false, status_types: [], allow_notes: true, callback: null })
            }
        })
    }

    React.useEffect(() => {
        if (serviceOrderLoadingStep === 0 && serviceOrder === undefined) {
            getData()
        } else if (serviceOrder !== undefined) {
            if (!serviceOrder.populatedWarranties) {
                serviceOrder.service_order_warranties = populateWarranties(serviceOrder)
                setServiceOrder({ ...serviceOrder, populatedWarranties: true })
            } else {
                setCalculatedCosts(calculateCosts(serviceOrder, warrantiedServices, warrantiedParts, warrantiedCharges, inputInMinutes))
                setWarrantiedServices(getWarrantiedServices(serviceOrder))
                setWarrantiedParts(getWarrantiedParts(serviceOrder))
                setWarrantiedCharges(getWarrantiedCharges(serviceOrder))
                autoPrintTag();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceOrder])

    React.useEffect(() => {
        if (serviceOrderLoadingStep === 0 && serviceOrder !== undefined) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceOrderId])

    React.useEffect(() => {
        window.history.replaceState(null, null, `#${tab}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab])

    React.useEffect(() => {
        let updates = false
        if (calculatedCosts && calculatedCosts.shop_fees_calculated !== undefined) {
            const shop_fees_calculated = Math.round(ShopFeesCalculation(serviceOrder, calculatedCosts, warrantiedServices, warrantiedParts, inputInMinutes) * 100) / 100
            if (shop_fees_calculated !== calculatedCosts.shop_fees_calculated && !isNaN(shop_fees_calculated)) {
                updates = true
                calculatedCosts.shop_fees_calculated = shop_fees_calculated
            }
        }
        if (calculatedCosts) {
            Object.keys(calculatedCosts.fees).forEach((fee_id) => {
                const fee = calculatedCosts.fees[fee_id]
                if (fee.service_order_fee_id === undefined || fee.edited) {
                    return
                }
                let new_value = 0
                if (fee.calculation_data.fee_type === 'Flat Rate') {
                    new_value = Math.round(fee.calculation_data.flat_rate * 100) / 100
                }
                if (calculatedCosts.ISQUOTE && new_value !== fee.estimated_cost) {
                    updates = true
                    fee.estimated_cost = new_value
                } else if (!calculatedCosts.ISQUOTE && new_value !== fee.actual_cost) {
                    updates = true
                    fee.actual_cost = new_value
                }
            })
        }
        if (updates) {
            console.log("Saw Update")
            setCalculatedCosts({ ...calculatedCosts })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calculatedCosts, inputInMinutes])

    const autoPrintTag = () => {
        //Auto Print Tag on First Creation.
        //TODO add some kind of ON / OFF setting company wide to not have it do this. Otherwise it defaults to always printing a tag on first creation.
        const printTagCheckIn = localStorage.getItem('printTagCheckIn');

        if (printTagCheckIn) {
            try {
                console.log('This is the First Time we Need to Print the Tag: ' + printTagCheckIn)
                //Lets try Printing if a Default Printer is Selected. 
                const current_location = findLocation(locations, serviceOrder.current_location_id)
                if ('ZEBRA_PRINTER' in current_location.integrations) {
                    var default_printer = localStorage.getItem(`default_service_zebra_printer:location_${current_location.id}`) ?? ""
                    //Check that the Default Printer is Actually in this Location. 
                    if (!current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.some((x) => x[0] === default_printer)) {
                        default_printer = ""
                        setSelectModal({
                            ...selectModal,
                            open: true,
                            title: 'Select Printer',
                            options: current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.map((x) => `${x[0]}`),
                            defaultOption: default_printer,
                            closeModal: (selection) => {
                                if (selection) {
                                    localStorage.setItem(`default_service_zebra_printer:location_${current_location.id}`, selection)
                                    print_zebra_label_cloud(generate_service_order_label(serviceOrder, locations),
                                        current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.find((x) => x[0] === selection)[1],
                                        current_location.id,
                                        () => {
                                            enqueueSnackbar(`Successfully sent label to printer`, { variant: 'success', autoHideDuration: 5000 })
                                        },
                                        (error) => {
                                            console.log(error)
                                            enqueueSnackbar(`print label failed: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error', autoHideDuration: 10000 })
                                        })
                                }
                                setSelectModal({ ...selectModal, open: false })
                            }
                        })
                    }
                    else {
                        print_zebra_label_cloud(generate_service_order_label(serviceOrder, locations),
                            current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.find((x) => x[0] === default_printer)[1],
                            current_location.id,
                            () => {
                                enqueueSnackbar(`Successfully sent label to printer`, { variant: 'success', autoHideDuration: 5000 })
                            },
                            (error) => {
                                console.log(error)
                                enqueueSnackbar(`print label failed: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error', autoHideDuration: 10000 })
                            })
                    }


                }
                localStorage.removeItem('printTagCheckIn') // Clear the Print Flag
            } catch (error) {
                localStorage.removeItem('printTagCheckIn') // Clear the Print Flag
            }
        }
    };

    const open_work_history = serviceOrder ? serviceOrder.service_order_work_history.filter((x) => x.end_time === null)[0] : undefined

    return (
        (<Box sx={{ mt: '-12px' }}>
            <LoadingBackdropIndeterminate
                open={serviceOrderLoadingStep > 0}
                text={"Loading Order"}
            />
            <LoadingBackdropIndeterminate
                open={serviceOrderSavingStep > 0}
                text={"Saving Order"}
            />
            <LoadingBackdropIndeterminate
                open={serviceOrderFilesUploadStep > 0}
                text={"Uploading File"}
            />
            {/* <LoadingBackdropIndeterminate
                open={contractInvoiceStep > 0}
                text={"Generating Invoice"}
            /> */}
            {serviceOrder && <Box>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Grid container alignItems={"center"}>
                        <Grid size="grow">
                            <Tabs
                                value={tab}
                                onChange={(e, value) => setTab(value)}
                                variant="standard"
                            >
                                <Tab
                                    label="Details"
                                    value="details"
                                    icon={<HandymanIcon />} iconPosition="start" sx={{ fontWeight: "bold" }}
                                />
                                <Tab
                                    label={['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type) ? "Quote" : "Invoice"}
                                    value={['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type) ? "quote" : "invoice"}
                                    icon={<CalculateIcon />} iconPosition="start" sx={{ fontWeight: "bold" }} />
                                <TooltipTab
                                    label="Payment"
                                    value="payment"
                                    icon={<Box sx={{ verticalAlign: 'middle' }}>
                                        {['DEPOSIT', 'PAYMENT_PENDING'].includes(serviceOrder.invoice.status) && <InfoIcon sx={{ height: '20px' }} color="error" />}
                                        <AttachMoneyIcon />
                                    </Box>}
                                    iconPosition="start"
                                    sx={{ fontWeight: "bold" }}
                                    tooltip={['DEPOSIT', 'PAYMENT_PENDING'].includes(serviceOrder.invoice.status) ? "Awaiting Payment" : ""}
                                />
                            </Tabs >
                        </Grid>
                        <Grid size="auto">
                            <IconButton onClick={() => closeFunction()}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>
                <TabPanel value={tab} value_key={"details"} sx={{ pt: 1 }}>
                    <Grid container justifyContent={'space-between'}>
                        <Grid size="auto">
                            <h2>Order
                                <IconButton
                                    aria-label="more"
                                    id="long-button"
                                    aria-controls={Boolean(serviceOrderOptionsAnchorEl) ? 'long-menu' : undefined}
                                    aria-expanded={Boolean(serviceOrderOptionsAnchorEl) ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={(e) => setServiceOrderOptionsAnchorEl(e.currentTarget)}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    id="long-menu"
                                    anchorEl={serviceOrderOptionsAnchorEl}
                                    open={Boolean(serviceOrderOptionsAnchorEl)}
                                    onClose={() => setServiceOrderOptionsAnchorEl(null)}
                                    slotProps={{
                                        list: {
                                            'aria-labelledby': 'long-button',
                                        }
                                    }}
                                >
                                    <MenuItem onClick={() => { setFilesModalOpen(true); setServiceOrderOptionsAnchorEl(null) }}>
                                        Files
                                    </MenuItem>
                                    <MenuItem onClick={() => { setSelectedWarranty(NEW_WARRANTY); setServiceOrderOptionsAnchorEl(null) }}>
                                        Create Warranty Claim
                                    </MenuItem>
                                    <MenuItem onClick={() => { setCurrentLocationModalOpen(true); setServiceOrderOptionsAnchorEl(null) }}>
                                        Transfer Location
                                    </MenuItem>
                                    <MenuItem onClick={() => { setServiceOrderSummaryNotesModal({ ...serviceOrderSummaryNotesModal, defaultInput: serviceOrder.summary_notes, open: true }); setServiceOrderOptionsAnchorEl(null) }}>
                                        Edit Order Summary Notes
                                    </MenuItem>
                                    <MenuItem onClick={() => {
                                        //print_zebra_label_local(
                                        //    generate_service_order_label(serviceOrder),
                                        //    '192.168.88.250',
                                        //    () => enqueueSnackbar(`Printed tag`),
                                        //    (error) => enqueueSnackbar(`Failed to print tag: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                                        //); setServiceOrderOptionsAnchorEl(null)
                                        // print_zebra_label_browserPrint('iA44i2HWk8b8PGGSG7kJaqicHSGp7qhq', '1092b81d1689b01e157f4fcfd5396828', generate_service_order_label(serviceOrder, locations), 'DFJ240902030', () => enqueueSnackbar(`Printed tag`), (error) => enqueueSnackbar(`Failed to print tag: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })); setServiceOrderOptionsAnchorEl(null)
                                        const current_location = findLocation(locations, serviceOrder.current_location_id)
                                        if ('ZEBRA_PRINTER' in current_location.integrations) {
                                            var default_printer = localStorage.getItem(`default_service_zebra_printer:location_${current_location.id}`) ?? ""
                                            if (!current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.some((x) => x[0] === default_printer)) {
                                                default_printer = ""
                                            }
                                            setSelectModal({
                                                ...selectModal,
                                                open: true,
                                                title: 'Select Printer',
                                                options: current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.map((x) => `${x[0]}`),
                                                defaultOption: default_printer,
                                                closeModal: (selection) => {
                                                    if (selection) {
                                                        localStorage.setItem(`default_service_zebra_printer:location_${current_location.id}`, selection)
                                                        print_zebra_label_cloud(generate_service_order_label(serviceOrder, locations),
                                                            current_location.integrations["ZEBRA_PRINTER"].ZEBRA_PRINTERS.find((x) => x[0] === selection)[1],
                                                            current_location.id,
                                                            () => {
                                                                enqueueSnackbar(`Successfully sent label to printer`, { variant: 'success', autoHideDuration: 5000 })
                                                            },
                                                            (error) => {
                                                                console.log(error)
                                                                enqueueSnackbar(`print label failed: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error', autoHideDuration: 10000 })
                                                            })
                                                    }
                                                    setSelectModal({ ...selectModal, open: false })
                                                }
                                            })
                                        }
                                        setServiceOrderOptionsAnchorEl(null)
                                    }}>
                                        Print Tag
                                    </MenuItem>

                                    <MenuItem onClick={() => { setEventsModalOpen(true); setServiceOrderOptionsAnchorEl(null) }}>
                                        Events
                                    </MenuItem>
                                    <MenuItem onClick={() => { setChangeServiceOrderCustomerModalOpen(true); setServiceOrderOptionsAnchorEl(null) }}>
                                        Change Customer
                                    </MenuItem>
                                    <MenuItem onClick={() => { cancel_service_order(); setServiceOrderOptionsAnchorEl(null) }} disabled={!['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type)}>
                                        Cancel Service Order
                                    </MenuItem>
                                </Menu>
                            </h2>
                        </Grid>
                        <Grid container spacing={1} alignItems={'start'}>
                            {['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) &&
                                <Grid container alignItems={'center'} size="auto">
                                    {open_work_history &&
                                        <Grid size="auto">
                                            <Tooltip arrow title={`Actively being worked by ${findUser(users, open_work_history.user_id)?.name}`}>
                                                <div>
                                                    <span>
                                                        <TimerIcon color="error" />
                                                    </span>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                    }
                                    <Grid size="auto">
                                        {openServiceOrderWorkHistory?.service_order_id === serviceOrder.id ?
                                            <Tooltip arrow title={''}>
                                                <div>
                                                    <span>
                                                        <Button color='orange' variant='contained' onClick={() => setStopWorkModalOpen(true)}>
                                                            <TimerIcon /><Box sx={{ pl: 1 }}>Stop Work</Box>
                                                        </Button>
                                                    </span>
                                                </div>
                                            </Tooltip>
                                            :
                                            (serviceOrder.status_type !== 'WORK_COMPLETE' && <Tooltip arrow title={''}>
                                                <div>
                                                    <span>
                                                        <StartWorkButton
                                                            serviceOrder={serviceOrder}
                                                            setOpenServiceOrderWorkHistory={setOpenServiceOrderWorkHistory}
                                                            setPendingServicesModal={setPendingServicesModal}
                                                        />
                                                    </span>
                                                </div>
                                            </Tooltip>)
                                        }
                                    </Grid>
                                </Grid>
                            }
                            <Grid size="auto">
                                <Button variant="contained" sx={{ mb: 1 }}>
                                    <input id="upload-serviceorder-file" type="file" accept="*" hidden onChange={(e) => uploadNewFile(e, setServiceOrderFilesUploadStep)} />
                                    <label htmlFor="upload-serviceorder-file" style={{ cursor: 'inherit' }}>
                                        <Box sx={{ display: 'flex' }}>
                                            <FileUploadIcon /><Box sx={{ pl: 1 }}>Add File</Box>
                                        </Box>
                                    </label>
                                </Button>
                            </Grid>
                            {serviceOrder.status_type === 'INVOICED' &&
                                <Grid size="auto">
                                    <Tooltip arrow title={!serviceOrder.invoice.paid ? 'Invoice not paid' : ''}>
                                        <div>
                                            <span>
                                                <Button color='success' variant='contained' onClick={complete_service_order} disabled={!serviceOrder.invoice.paid}>Complete</Button>
                                            </span>
                                        </div>
                                    </Tooltip>
                                </Grid>
                            }
                            {serviceOrder.service_order_services.length > 0 && ['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type) && serviceOrder.service_order_services.every(x => x.customer_approved_status === 'DECLINED' || x.status === 'DECLINED') &&
                                <Grid size="auto">
                                    <Button color='error' variant='contained' onClick={cancel_service_order}>Cancel</Button>
                                </Grid>
                            }
                            {serviceOrder.status_type === 'INVOICED' &&
                                <Grid size="auto">
                                    <Button color='error' variant='contained' onClick={revert_from_invoiced}>Reverse</Button>
                                </Grid>
                            }
                            {['COMPLETED', 'DECLINED'].includes(serviceOrder.status_type) &&
                                <Grid size="auto">
                                    <Button color='error' variant='contained' onClick={reopen_service_order}>Reopen</Button>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <Grid container columns={{ xs: 6, sm: 12 }} rowSpacing={2} alignItems={'flex-start'}>
                        <Grid container alignItems={'center'} rowSpacing={0} size={6}>
                            <Grid size={12}>
                                <span>Order: #{serviceOrder.id}</span>
                            </Grid>
                            <Grid size="auto">
                                <span>Status:</span>
                            </Grid>
                            <Grid size="grow">
                                <ServiceOrderStatusDropdown
                                    serviceOrder={serviceOrder}
                                    setServiceOrder={setServiceOrder}
                                    setMadeUpdate={setMadeUpdate}
                                    setServiceOrderSavingStep={setServiceOrderSavingStep}
                                    allow_customer_communication={true}
                                />
                            </Grid>
                            <Grid container size={12}>
                                <Grid size="auto">
                                    <span>Customer:</span><Button onClick={() => setCustomerModalOpen(true)}>{formatCustomerName(serviceOrder.customer)}</Button>
                                </Grid>
                                <Grid size="auto">
                                    <Button onClick={() => setOpenCustomerCommunicationModal(true)}><span>Send</span><PhoneAndroidIcon /><span style={{ fontSize: '24px', lineHeight: '24px' }}>/</span><EmailIcon /></Button>
                                </Grid>
                            </Grid>
                            <Grid size={"auto"}>
                                <span>Preferred Contact:</span>
                            </Grid>
                            <Grid size="grow">
                                <ServiceOrderPreferredContact
                                    serviceOrder={serviceOrder}
                                    setServiceOrder={setServiceOrder}
                                    setServiceOrderSavingStep={setServiceOrderSavingStep}
                                    editable={true}
                                />
                            </Grid>
                            {serviceOrder.customer_approved_status !== 'NOT_REQUESTED' &&
                                <Grid size={12}>
                                    <span>Approval: {<Chip label={SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES[serviceOrder.customer_approved_status]} color={SERVICE_ORDER_CUSTOMER_APPROVAL_COLOR_MAP[serviceOrder.customer_approved_status] || 'primary'} />}</span>
                                </Grid>
                            }
                        </Grid>
                        <Grid container direction="column" spacing={1} size={6}>
                            <Grid>
                                <Autocomplete
                                    key={loadedUsers}
                                    sx={{ color: 'rgba(0, 0, 0, 0.6)', maxWidth: '300px' }}
                                    getOptionLabel={(option) => `${option.name || ""}`}
                                    options={build_users_list(users, my_user, false, loadedUsers, true, serviceOrder.current_location_id ?? 'all')}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    autoComplete
                                    includeInputInList
                                    // disableClearable
                                    value={build_users_list(users, my_user, false, loadedUsers).find((x) => x.id === serviceOrder.assignee_user_id) ?? {}}
                                    noOptionsText="No Users"
                                    loading={!loadedUsers}
                                    onChange={(event, newValue, reason) => {
                                        console.log(newValue, reason)
                                        if (newValue === null && reason === 'clear' && event.type === 'change') {
                                            return // Don't allow clearing by backspacing or deleting. Only by clicking the clear button.
                                        }
                                        setAssignee(newValue)
                                    }}
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                minWidth: '250px'
                                            }
                                        }
                                    }}
                                    renderInput={(params) => {
                                        let avatar = undefined
                                        if (params.inputProps["aria-expanded"]) {
                                            avatar = (
                                                <span><UserAvatar user={{}} /></span>
                                            )
                                        } else {
                                            avatar = (
                                                <span><UserAvatar user={findUser(users, serviceOrder.assignee_user_id) ?? {}} /></span>
                                            )
                                        }
                                        return (
                                            (<div style={{ position: "relative" }}>
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        transform: "translateY(50%)",
                                                        marginLeft: "5px"
                                                    }}
                                                >
                                                    {avatar}
                                                </span>
                                                <TextField
                                                    {...params}
                                                    label="Assignee"
                                                    autoComplete='off'
                                                    type="text"
                                                    slotProps={{
                                                        htmlInput: {
                                                            ...params.inputProps,
                                                            style: {
                                                                padding: "4px 4px 0 32px",
                                                                height: '36px'
                                                            }
                                                        },

                                                        inputLabel: {
                                                            shrink: true,
                                                            ...params.InputLabelProps,
                                                        }
                                                    }} />
                                            </div>)
                                        );
                                    }}
                                    renderOption={(props, option, { inputValue }) => {
                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                        const parts = parse(props.key, matches);
                                        const li_props = { ...props }
                                        delete li_props.key

                                        return (
                                            (<li {...li_props} key={props.id}>
                                                <Grid container space={1} alignItems="center">
                                                    <Grid sx={{ pr: 1 }} size="auto">
                                                        <span><UserAvatar user={option} /></span>
                                                    </Grid>
                                                    <Grid size="auto">
                                                        {parts.map((part, index) => (
                                                            <span
                                                                key={index}
                                                                style={{
                                                                    fontWeight: part.highlight ? 700 : 400,
                                                                }}
                                                            >
                                                                {part.text}
                                                            </span>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </li>)
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid>
                                <Box display={'flex'}>
                                    <Box sx={{ pr: 1 }}>
                                        <span>Drop-Off: </span>
                                        <br /><br />
                                        <span>Current Location: </span>
                                        <br /><br />
                                    </Box>
                                    <Box>
                                        <span>{dayjs.utc(serviceOrder.date_created).local().format(LONG_DATE_FORMAT)}</span>
                                        <br />
                                        <span>{findLocation(locations, serviceOrder.location_id)?.name}</span>
                                        <br />
                                        <span>{serviceOrder.current_location_updated ? dayjs.utc(serviceOrder.current_location_updated).local().format(LONG_DATE_FORMAT) : 'N/A'}</span>
                                        <br />
                                        <span>{serviceOrder.current_location_id ? findLocation(locations, serviceOrder.current_location_id)?.name : 'N/A'}</span>
                                    </Box>
                                </Box>
                            </Grid>
                            {serviceOrder.service_order_warranties.map((warranty) =>
                                <Grid key={warranty.id}>
                                    <Box bgcolor={'lightOrange.main'} display={'grid'} sx={{ p: 2, width: 'fit-content', position: 'relative' }}>
                                        <IconButton
                                            aria-label="close"
                                            onClick={() => setSelectedWarranty(warranty)}
                                            sx={{
                                                position: 'absolute',
                                                right: 8,
                                                top: 8
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <span style={{ "paddingRight": "40px" }}><b>Warranty Claim</b></span>
                                        <span>Claim #{warranty.claim_number}</span>
                                        <span>Vendor: {warranty.vendor}</span>
                                        <span>Created: {dayjs.utc(warranty.date_created).local().format("MM/DD/YYYY")}</span>
                                        <span>Status: {warranty.status}</span>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container columns={{ xs: 6, sm: 12 }} rowSpacing={1}>
                        <Grid size={6}>
                            <h2>Item
                                {serviceOrder.customer_item.purchased_from_us &&
                                    <Tooltip title={`Purchased from us ${serviceOrder.customer_item.purchase_date ? `on ${dayjs.utc(serviceOrder.customer_item.purchase_date).format('M/D/YYYY')}` : ''}`}>
                                        <StorefrontIcon sx={{ height: '100%', verticalAlign: 'middle' }} />
                                    </Tooltip>
                                }
                                <IconButton
                                    aria-label="more"
                                    id="long-button"
                                    aria-controls={Boolean(serviceOrderItemOptionsAnchorEl) ? 'long-menu' : undefined}
                                    aria-expanded={Boolean(serviceOrderItemOptionsAnchorEl) ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={(e) => setServiceOrderItemOptionsAnchorEl(e.currentTarget)}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    id="long-menu"
                                    anchorEl={serviceOrderItemOptionsAnchorEl}
                                    open={Boolean(serviceOrderItemOptionsAnchorEl)}
                                    onClose={() => setServiceOrderItemOptionsAnchorEl(null)}
                                    slotProps={{
                                        list: {
                                            'aria-labelledby': 'long-button',
                                        }
                                    }}
                                >
                                    <MenuItem onClick={() => { editCustomerItemClick(); setServiceOrderItemOptionsAnchorEl(null) }}>
                                        Edit Item
                                    </MenuItem>
                                    <MenuItem onClick={() => { setCustomerItemHistoryModal(true); setServiceOrderItemOptionsAnchorEl(null) }}>
                                        History
                                    </MenuItem>
                                </Menu>
                            </h2>
                            <Grid container columnSpacing={3}>
                                <Grid size="auto">
                                    <Grid container direction="column" spacing={0.25}>
                                        <Grid size="grow">
                                            <span>Manufacturer:</span>
                                        </Grid>
                                        <Grid size="grow">
                                            <span>Model:</span>
                                        </Grid>
                                        <Grid size="grow">
                                            <span>Identifier:</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size="grow">
                                    <Grid container direction="column" spacing={0.25}>
                                        <Grid size="grow">
                                            <span className="span-always-visible">{serviceOrder.customer_item.manufacturer}</span>
                                        </Grid>
                                        <Grid size="grow">
                                            <span className="span-always-visible">{serviceOrder.customer_item.model}</span>
                                        </Grid>
                                        <Grid size="grow">
                                            <span className="span-always-visible">{serviceOrder.customer_item.identifier}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12}>
                                    <ExpandMore
                                        expand={customerItemExpanded ?? false}
                                        onClick={() => setCustomerItemExpanded(!customerItemExpanded)}
                                        aria-expanded={customerItemExpanded ?? false}
                                        aria-label="show more"
                                    >
                                        <ExpandMoreIcon />
                                    </ExpandMore>
                                    <span onClick={() => setCustomerItemExpanded(!customerItemExpanded)}>Show More</span>
                                </Grid>
                                <Grid size={12}>
                                    <Collapse in={customerItemExpanded ?? false} timeout="auto" unmountOnExit>
                                        <Grid container spacing={3}>
                                            <Grid size="auto" container direction="column" spacing={0.25}>
                                                <Grid size="grow">
                                                    <span>Type:</span>
                                                </Grid>
                                                <Grid size="grow">
                                                    <span>Purchase Date:</span>
                                                </Grid>
                                                {Object.keys(serviceOrder.customer_item.extra_attrs ?? {}).sort((a, b) => {
                                                    const a_index = (SERVICE_ORDER_ITEM_TYPE?.extra_attrs ?? []).indexOf(a);
                                                    const b_index = (SERVICE_ORDER_ITEM_TYPE?.extra_attrs ?? []).indexOf(b);

                                                    return (a_index === -1 ? Infinity : a_index) - (b_index === -1 ? Infinity : b_index);
                                                }).map((attr) =>
                                                    <Grid size="grow" key={attr}>
                                                        <span>{attr}:</span>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Grid size="grow" container direction="column" spacing={0.25}>
                                                <Grid size="grow">
                                                    <span className="span-always-visible">{SERVICE_ORDER_ITEM_TYPE?.name}</span>
                                                </Grid>
                                                <Grid size="grow">
                                                    <span className="span-always-visible">{serviceOrder.customer_item.purchase_date ? dayjs.utc(serviceOrder.customer_item.purchase_date).format('M/D/YYYY') : 'Unknown'}</span>
                                                </Grid>
                                                {Object.keys(serviceOrder.customer_item.extra_attrs ?? {}).sort((a, b) => {
                                                    const a_index = (SERVICE_ORDER_ITEM_TYPE?.extra_attrs ?? []).indexOf(a);
                                                    const b_index = (SERVICE_ORDER_ITEM_TYPE?.extra_attrs ?? []).indexOf(b);

                                                    return (a_index === -1 ? Infinity : a_index) - (b_index === -1 ? Infinity : b_index);
                                                }).map((attr) =>
                                                    <Grid size="grow" key={attr}>
                                                        <span className="span-always-visible">{serviceOrder.customer_item.extra_attrs[attr]}</span>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Collapse>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={6}>
                            <h4>Customer Drop Off Notes</h4>
                            <Box sx={{ m: 1, p: 0.5, bgcolor: `backgroundColor.${darkMode ? 'light' : 'dark'}`, borderRadius: "8px 8px 0 0" }}>
                                <span>{serviceOrder.customer_notes}</span>
                            </Box>
                            <Box sx={{ justifyContent: 'flex-end', display: 'flex', alignItems: 'center', pr: 1, gap: 1 }}>
                                <AIButton make_prompt={() => { return { prompt: `${serviceOrder.customer_item.manufacturer} ${serviceOrder.customer_item.model} has the problem "${serviceOrder.customer_notes}" As a professional, how do I diagnose and fix it?` } }}>
                                    Help Diagnose
                                </AIButton>
                            </Box>

                        </Grid>
                        {serviceOrder.service_order_work_history.some((x) => x.diagnostic_minutes || x.diagnostic_note) &&
                            <Grid size={12}>
                                <Accordion disableGutters defaultExpanded={false} sx={{ mt: 1 }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="diagnostic-work-history-content"
                                        id="diagnostic-work-history-header"
                                    >
                                        <Typography>Diagnostic Work History</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <DataGrid
                                            // key={windowInnerWidth}
                                            rows={serviceOrder.service_order_work_history}
                                            columns={workHistoryColumns}
                                            disableRowSelectionOnClick
                                            autoHeight={true}
                                            hideFooter
                                            getRowId={(row) => row.start_time + row.end_time}
                                            getRowHeight={() => 'auto'}
                                            getEstimatedRowHeight={() => 135}
                                            sx={{
                                                [`& .${gridClasses.cell}`]: {
                                                    py: 1,
                                                },
                                            }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        }
                    </Grid>
                    <Grid container spacing={3} alignItems="center">
                        <Grid size="auto">
                            <h2>Services {serviceOrder.service_order_services.length ? `(${serviceOrder.service_order_services.length})` : ''}</h2>
                        </Grid>
                        {['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) &&
                            <Grid size="grow">
                                <Button onClick={() => setAddServiceModalOpen(true)} disabled={serviceOrder.status_type === 'WORK_COMPLETE'}>
                                    <AddCircleSharpIcon /> <Box sx={{ pl: 1 }}>Add Service</Box>
                                </Button>
                            </Grid>
                        }
                    </Grid>
                    <Grid container rowSpacing={1}>
                        {serviceOrder.service_order_services.toSorted((a, b) => dayjs.utc(b.date_created).unix() - dayjs.utc(a.date_created).unix()).map((service) => (
                            <Grid size={12} key={service.id}>
                                <ServiceOrderService
                                    serviceOrder={serviceOrder}
                                    service={service}
                                    setServiceOrder={setServiceOrder}
                                    setMadeUpdate={setMadeUpdate}
                                    setServiceOrderSavingStep={setServiceOrderSavingStep}
                                    warrantiedServices={warrantiedServices}
                                    warrantiedParts={warrantiedParts}
                                />
                            </Grid>)
                        )}
                    </Grid>
                    <ServiceOrderNotes
                        serviceOrder={serviceOrder}
                        setServiceOrder={setServiceOrder}
                        defaultExpanded={true}
                    />
                </TabPanel>
                <TabPanel value={tab} value_key={['CREATED', 'IN_PROGRESS'].includes(serviceOrder.status_type) ? "quote" : "invoice"} sx={{ pt: 1 }}>
                    <ServiceOrderQuoteInvoice
                        serviceOrder={serviceOrder}
                        setServiceOrder={setServiceOrder}
                        setMadeUpdate={setMadeUpdate}
                        calculatedCosts={calculatedCosts}
                        setCalculatedCosts={setCalculatedCosts}
                        setTab={setTab}
                        isQuote={ISQUOTE}
                        warrantiedServices={warrantiedServices}
                        warrantiedParts={warrantiedParts}
                        warrantiedCharges={warrantiedCharges}
                    />
                </TabPanel>
                <TabPanel value={tab} value_key={"payment"} sx={{ pt: 1 }}>
                    <PaymentPage
                        open={tab === "payment"}
                        invoice={serviceOrder.invoice}
                        serviceOrder={serviceOrder}
                        location_id={serviceOrder.location_id}
                        sendUpdate={paymentUpdate}
                        customer={serviceOrder.customer}
                    />
                </TabPanel>
                <CustomerModal
                    customer={serviceOrder.customer}
                    open={customerModalOpen}
                    closeModal={(changes) => {
                        setCustomerModalOpen(false)
                        if (changes) {
                            setServiceOrder(undefined)
                            setMadeUpdate(true)
                        }
                    }}
                />
                <SelectModal
                    {...selectModal}
                />
                {/* Used for service order summary notes editing */}
                <InputModal
                    {...serviceOrderSummaryNotesModal}
                />
                <CustomerItemModal
                    open={customerItemModal.open}
                    customerItem={customerItemModal.customerItem}
                    closeModal={closeCustomerItemModal}
                    creatingNewCustomerItem={false}
                />
                <CustomerItemHistoryModal
                    open={customerItemHistoryModal}
                    customerItem={serviceOrder.customer_item}
                    closeModal={() => setCustomerItemHistoryModal(false)}
                />
                <AddServiceOrderServiceModal
                    serviceOrder={serviceOrder}
                    open={addServiceModalOpen}
                    closeModal={closeModalFunction(setAddServiceModalOpen)}
                />
                <ChangeServiceOrderStatusModal
                    serviceOrder={serviceOrder}
                    {...statusModalOpen}
                    default_customer_communication_type={(serviceOrder.preferred_phone && 'text') || (serviceOrder.preferred_email && 'email') || serviceOrder.customer.preferred_communication_type}
                    default_phone={serviceOrder.preferred_phone || serviceOrder.customer.phone}
                    default_email={serviceOrder.preferred_email || serviceOrder.customer.email}
                    phones={(serviceOrder.preferred_phone ? [{ value: serviceOrder.preferred_phone, name: "Preferred Contact" }] : []).concat(
                        serviceOrder.customer.phone ? [{ value: serviceOrder.customer.phone, name: formatCustomerName(serviceOrder.customer) }] : []
                    ).concat(
                        (serviceOrder.customer.customer_contacts ?? []).sort((a, b) => (a.first_name + ' ' + a.last_name).localeCompare(b.first_name + ' ' + b.last_name)).map((contact) => contact.phone ? { value: contact.phone, name: `${contact.first_name} ${contact.last_name}` } : undefined).filter((x) => x !== undefined)
                    )}
                    emails={(serviceOrder.preferred_email ? [{ value: serviceOrder.preferred_email, name: "Preferred Contact" }] : []).concat(
                        serviceOrder.customer.email ? [{ value: serviceOrder.customer.email, name: formatCustomerName(serviceOrder.customer) }] : []
                    ).concat(
                        (serviceOrder.customer.customer_contacts ?? []).sort((a, b) => (a.first_name + ' ' + a.last_name).localeCompare(b.first_name + ' ' + b.last_name)).map((contact) => contact.email ? { value: contact.email, name: `${contact.first_name} ${contact.last_name}` } : undefined).filter((x) => x !== undefined)
                    )}
                />
                <ChangeCustomerApprovalStatusModal
                    serviceOrder={serviceOrder}
                    open={changeCustomerApprovalStatusModalOpen}
                    closeModal={closeModalFunction(setChangeCustomerApprovalStatusModalOpen)}
                />
                <PendingServicesModal
                    open={pendingServicesModal}
                    serviceOrder={serviceOrder}
                    setServiceOrder={setServiceOrder}
                    setMadeUpdate={setMadeUpdate}
                    callback={() => setPendingServicesModal(false)}
                />
                <StopWorkModal
                    serviceOrder={serviceOrder}
                    serviceOrderWorkHistory={openServiceOrderWorkHistory}
                    open={stopWorkModalOpen}
                    closeModal={closeModalFunction(setStopWorkModalOpen)}
                />
                <ServiceOrderEventsModal
                    open={eventsModalOpen}
                    serviceOrder={serviceOrder}
                    closeModal={() => setEventsModalOpen(false)}
                />
                <ServiceOrderFilesModal
                    open={filesModalOpen}
                    serviceOrder={serviceOrder}
                    uploadNewFile={uploadNewFile}
                    closeModal={() => setFilesModalOpen(false)}
                />
                <ServiceOrderWarrantyModal
                    serviceOrderWarranty={selectedWarranty ?? {}}
                    services={serviceOrder.service_order_services}
                    charges={serviceOrder.service_order_charges}
                    open={selectedWarranty !== undefined}
                    closeModal={(results) => {
                        setSelectedWarranty(undefined)
                        if (results) {
                            setServiceOrder(undefined)
                            setMadeUpdate(true)
                        }
                    }}
                    creatingNew={selectedWarranty?.new ?? false}
                    serviceOrderId={serviceOrder?.id}
                />
                <CurrentLocationModal
                    open={currentLocationModalOpen}
                    closeModal={(results) => {
                        setCurrentLocationModalOpen(false)
                        if (results) {
                            setServiceOrder(results)
                            setMadeUpdate(true)
                        }
                    }}
                    serviceOrderId={serviceOrder?.id}
                    currentLocation={serviceOrder.current_location_id}
                />
                <CustomerCommunicationModal
                    serviceOrder={serviceOrder}
                    setServiceOrder={setServiceOrder}
                    setServiceOrderSavingStep={setServiceOrderSavingStep}
                    open={openCustomerCommunicationModal}
                    closeModal={(success) => {
                        setOpenCustomerCommunicationModal(false)
                    }}
                    allow_ai={my_user?.client?.has_ai ?? false}
                />
                <ChangeServiceOrderCustomerModal
                    open={changeServiceOrderCustomerModalOpen}
                    serviceOrder={serviceOrder}
                    closeModal={(results) => {
                        setChangeServiceOrderCustomerModalOpen(false)
                        if (results) {
                            setServiceOrder(results)
                            setMadeUpdate(true)
                        }
                    }}
                />
            </Box>
            }
        </Box >)
    );
}
